module.exports = " <table class=\"table table-responsive table-hover admin-table\"> <thead> <tr> <th>N°</th> <th>Título</th> <th>Descuento</th> <th>Vigencia</th> <th>Utilizada</th> <th></th> </tr> </thead> <tbody> <tr class=clickable-row> <td></td> <td></td> <td></td> <td></td> <td></td> <td> <i class=\"fa fa-pencil\" aria-hidden=true></i> <i class=\"fa fa-trash\" aria-hidden=true @click=remove(item)></i> </td> </tr> </tbody> </table> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/Admin-table-codes.vue
// module id = 540
// module chunks = 0